export default {"src":"/_next/static/media/linkedin.8466192a.svg","height":24,"width":24};